import classNames from 'classnames'

import { CHARACTER_WHITESPACE } from '../../../../constants/common'
import Text from '../../../Text'
import { BIRDVIEW_TREND_GLYPH } from '../../DashboardBirdview.constants.charts'
import { QA_NAME_DASHBOARD_BIRDVIEW_TILE_DELTA } from '../../DashboardBirdview.constants.qa'

import * as styles from './DashboardTileDelta.module.css'

function DashboardTileDelta({ direction, text, tone }) {
  return (
    <Text
      className={classNames(styles.delta, styles[tone])}
      qaName={QA_NAME_DASHBOARD_BIRDVIEW_TILE_DELTA}
    >
      {[BIRDVIEW_TREND_GLYPH[direction], text]
        .filter(Boolean)
        .join(CHARACTER_WHITESPACE)}
    </Text>
  )
}

export default DashboardTileDelta
